export default __webpack_public_path__ + "static/media/Category-C-Carpet.989e5195.jpg";